import request from '@/utils/request'; //登录sdk配置 新增配置

export function addLginConfig(data) {
  return request({
    url: 'pay/add_login_sdk',
    method: 'post',
    params: data
  });
}